import { useCallback, useState } from "react"
import { useFormikContext } from "formik"
import { makeStyles } from "tss-react/mui"
import { Button, Grid, IconButton, List, ListItem, ListItemText, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { CreateUpdateProductFormValues } from "../productsTypes"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus, faPen } from "@fortawesome/pro-solid-svg-icons"
import { useMoney } from "../../../../currency/useMoney"
import { toDinero } from "../../../../currency/currencyLib"
import { AddToPriceListDialog } from "./addToPriceListDialog/AddToPriceListDialog"

const useStyles = makeStyles()((theme) => ({
    boxTitle: {
        color: theme.palette.tailwind.slate[500],
    },
    list: {
        width: "100%",
    },
    listItem: {
        display: "flex",
        gap: "1.5rem",
        justifyContent: "space-between",
        borderBottom: `1px solid ${theme.palette.tailwind.slate[200]}`,
        padding: "0.5rem 0",
    },
    button: {
        textTransform: "none",
        borderRadius: "0.5rem",
    },
}))
export type DialogStateProps = Readonly<{ show: boolean; id: null | number }>

type PriceListBoxProps = Readonly<{}>

export function PriceListBox({}: PriceListBoxProps) {
    const { values } = useFormikContext<CreateUpdateProductFormValues>()
    const moneyFactory = useMoney({})
    const { classes } = useStyles()

    const [dialogState, setDialogState] = useState<DialogStateProps>({
        show: false,
        id: null,
    })

    const handleShowDialog = useCallback(
        (id: null | number) => {
            setDialogState((prev) => ({ id, show: !prev.show }))
        },
        [setDialogState],
    )

    return (
        <Grid container gap={3} flexDirection="column" alignItems="flex-end">
            {values.priceLists && values.priceLists.length > 0 && (
                <List disablePadding className={classes.list}>
                    {values.priceLists.map(({ id, name, adjustedPrice }) => (
                        <ListItem key={`price-list-${id}`} disableGutters className={classes.listItem}>
                            <ListItemText primaryTypographyProps={{ variant: "subtitle2" }}>{name}</ListItemText>
                            <Grid container gap={3} width="auto" alignItems="center" flex="none">
                                <Typography variant="subtitle2">
                                    {moneyFactory.format(toDinero(adjustedPrice))}
                                </Typography>
                                <IconButton onClick={() => handleShowDialog(id)}>
                                    <FontAwesomeIcon icon={faPen} fontSize="16px" color="#2196F3" />
                                </IconButton>
                            </Grid>
                        </ListItem>
                    ))}
                </List>
            )}
            <LocalizedStrict id="product-create-add-price-list-button">
                <Button
                    onClick={() => handleShowDialog(null)}
                    color="primary"
                    variant="outlined"
                    startIcon={<FontAwesomeIcon icon={faPlus} />}
                    size="small"
                    className={classes.button}
                >
                    Add price list
                </Button>
            </LocalizedStrict>
            {dialogState.show && (
                <AddToPriceListDialog
                    open={dialogState.show}
                    onClose={() => handleShowDialog(null)}
                    dialogStateId={dialogState.id}
                />
            )}
        </Grid>
    )
}
